import { absoluteUrl } from './pageSeo';
import { getProductPath } from './productUrl';

export const DEFAULT_AVAILABILITY_MESSAGE_TEMPLATE = `Hello,

I discovered this offer on Raheasy and I'm interested in purchasing it. Could you please confirm its availability and provide any relevant details?

Thank you.

Product: {productName}
{productUrl}`;

export function renderAvailabilityMessage(template, { productName, productUrl, storeName } = {}) {
  const base = String(template || DEFAULT_AVAILABILITY_MESSAGE_TEMPLATE).trim();
  return base
    .replace(/\{productName\}/g, String(productName || 'this product').trim())
    .replace(/\{productUrl\}/g, String(productUrl || '').trim())
    .replace(/\{storeName\}/g, String(storeName || '').trim());
}

export function buildAvailabilityMessageForProduct(product, options = {}) {
  const template = options.template || DEFAULT_AVAILABILITY_MESSAGE_TEMPLATE;
  const productName = product?.name || '';
  const productUrl =
    options.productPageUrl ||
    (product ? absoluteUrl(getProductPath(product)) : '');
  const storeName = product?.storeName || product?.vendor || '';
  return renderAvailabilityMessage(template, { productName, productUrl, storeName });
}
